import React, { useEffect, useState } from 'react';

const Popup = ({
  showPopup,
  status,
  message,
  timeout = 5000,
  onClose
}) => {
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    if (showPopup && !timer) {
      setTimer(setTimeout(() => onClose && onClose(), timeout));
    } else if (!showPopup && timer) {
      timer && clearTimeout(timer);
      setTimer(null);
    }
  }, [timer, showPopup, timeout, onClose]);

  return (
    <div className={`popup${status ? ' status--' + status : ''}${showPopup ? ' popup--show' : ''}`}>
      <p className="popup__message">{message}</p>
    </div>
  );
}

export default Popup;